import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import TableComponent from "./components/TableComponent";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import Tally from "./components/Tally";
import ArrivalDepartureEmails from "../../Emails/ArrivalDepartureEmails/ArrivalDepartureEmails";

function ArrivalDepartureHome() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  const [Registers, setRegisters] = useState([]);
  useEffect(() => {
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      // { ProgrammeTitle: "Summer", SEF: "Awaiting_Review" },
      {
        ProgrammeTitle: "Summer",
        ProgrammeVarient: "airport",
        SummerArrivalDepartureProgress: "Awaiting_Review",
      },
      20,
      setRegisters,
      logout
    );
  }, []);

  //-----------------------------Flatten Data For Export--------------------------------------------

  let FlattenedData = Registers.map((OneAttendee) => {
    return deepFlattenToObject(OneAttendee);
  });

  const [FilterEverything, setFilterEverything] = useState("");
  const handleFilterEverything = (e) => {
    setFilterEverything(e.target.value);
  };

  //Creates a variable called RegistersFiltered that filters the Registers based on the FilterEverything state. This only returns true if any of the fields in the Register, and any nested fields, includes the each word FilterEverything state as seperated by spaces.
  let RegistersFiltered = Registers.filter((Register) => {
    return FilterEverything.split(" ").every((word) => {
      return Object.values(Register).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  // -----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <SearchSetRegisters
          setRegisters={setRegisters}
          initialSearch={{
            ProgrammeTitle: "Summer",
            SummerArrivalDepartureProgress: "Awaiting_Review",
            ProgrammeVarient: "airport",
          }}
        />
        <TextField
          id="FilterEverything"
          label="Filter Everything"
          variant="outlined"
          value={FilterEverything}
          onChange={handleFilterEverything}
          fullWidth
          sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
        />

        <DisplayExport excelData={FlattenedData} fileName="Registers_Data" />
        <Tally />

        <TableComponent
          style={{ flex: "0 1 auto" }}
          Registers={RegistersFiltered}
          setRegisters={setRegisters}
        />
      </div>
    </div>
  );
}

export default ArrivalDepartureHome;
